/** Page numbers with ellipses: 1 … 4 5 [6] 7 8 … 20 */
export function pageList(page: number, pages: number, around = 1): (number | 'gap')[] {
  const out: (number | 'gap')[] = [];
  for (let p = 1; p <= pages; p++) {
    if (p === 1 || p === pages || Math.abs(p - page) <= around) out.push(p);
    else if (out.at(-1) !== 'gap') out.push('gap');
  }
  return out;
}
